//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BrowserMixin from "../../../shared/utils/application-mixins/browser-mixin";
import { replaceSVG } from "../../utils/utils";
import SectionError from "./section-error.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "GridSection",
  components: {
    SectionError
  },
  mixins: [BrowserMixin],
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    },
    path: {
      type: String,
      default: ""
    },
    value: {
      type: null,
      default: null
    },
    checked: {
      type: null,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    },
    translationMap: {
      type: Object,
      default: null
    }
  },
  computed: {
    squaresSize() {
      return this.options.length % 3 === 0 ? "col-4" : "col-lg-3 col-sm-6 col-12";
    },
    optionsSizeClass() {
      return this.recommendedBrowser() ? "" : "no-flex-col";
    }
  },
  mounted() {
    replaceSVG();
  },
  methods: {
    radioId(value) {
      return `${this.path}[${this.name}]-${value}`;
    },
    handleInput(e) {
      this.$emit("change", e.target.value);
    },
    getImgUrl(imgSrc) {
      const images = require.context("@Shared/@Assets/", true, /\.svg/);
      const path = imgSrc.split("shared/assets/")[1];
      return images(`./${path}`);
    }
  }
});